import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.concat.js";
import { Context } from '@nuxt/types';
import Applicant from '~/models/Applicant';
import Employee from '~/models/Employee';
var Auth = /*#__PURE__*/function () {
  function Auth(store) {
    _classCallCheck(this, Auth);
    this.$store = store;
    this.storeKey = 'auth';
  }
  _createClass(Auth, [{
    key: "loggedIn",
    get: function get() {
      return this.state('loggedIn');
    }
  }, {
    key: "me",
    get: function get() {
      return this.state('me');
    }
  }, {
    key: "user",
    get: function get() {
      return this.getter('user');
    }
  }, {
    key: "userType",
    get: function get() {
      return this.getter('userType');
    }
  }, {
    key: "isEmployee",
    get: function get() {
      return this.getter('isEmployee');
    }
  }, {
    key: "isApplicant",
    get: function get() {
      return this.getter('isApplicant');
    }
  }, {
    key: "isTenantMember",
    get: function get() {
      return this.getter('isTenantMember');
    }
  }, {
    key: "isAdmin",
    get: function get() {
      return this.getter('isAdmin');
    }
  }, {
    key: "isLoggedIn",
    get: function get() {
      return this.getter('isLoggedIn');
    }
  }, {
    key: "isGuest",
    get: function get() {
      return this.getter('isGuest');
    }
  }, {
    key: "isVerified",
    get: function get() {
      return this.getter('isVerified');
    }
  }, {
    key: "login",
    value: function login(payload) {
      return this.dispatch('login', payload);
    }
  }, {
    key: "register",
    value: function register(payload) {
      return this.dispatch('register', payload);
    }
  }, {
    key: "logout",
    value: function logout() {
      return this.dispatch('logout');
    }
  }, {
    key: "forgotPassword",
    value: function forgotPassword(payload) {
      return this.dispatch('forgotPassword', payload);
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(payload) {
      return this.dispatch('resetPassword', payload);
    }
  }, {
    key: "changePassword",
    value: function changePassword(payload) {
      return this.dispatch('changePassword', payload);
    }
  }, {
    key: "fetchMe",
    value: function fetchMe(payload) {
      return this.dispatch('fetchMe', payload);
    }
  }, {
    key: "updateUser",
    value: function updateUser(payload) {
      return this.dispatch('updateUser', payload);
    }
  }, {
    key: "state",
    value: function state(key) {
      return this.$store.state[this.storeKey][key];
    }
  }, {
    key: "getter",
    value: function getter(key) {
      return this.$store.getters["".concat(this.storeKey, "/").concat(key)];
    }
  }, {
    key: "commit",
    value: function commit(key, payload) {
      return this.$store.commit("".concat(this.storeKey, "/").concat(key), payload);
    }
  }, {
    key: "dispatch",
    value: function dispatch(method, payload) {
      return this.$store.dispatch("".concat(this.storeKey, "/").concat(method), payload);
    }
  }, {
    key: "hasOnboarded",
    value: function hasOnboarded() {
      if (this.isApplicant) {
        return new Applicant(this.me).hasOnboarded();
      }
      if (this.isEmployee) {
        return new Employee(this.me).hasOnboarded();
      }
      return true;
    }
  }, {
    key: "getOnboardingRoute",
    value: function getOnboardingRoute() {
      if (this.isApplicant) {
        return new Applicant(this.me).getOnboardingRoute();
      }
      if (this.isEmployee) {
        return new Employee(this.me).getOnboardingRoute();
      }
      return '';
    }
  }]);
  return Auth;
}();
var authPlugin = function authPlugin(_ref, inject) {
  var store = _ref.store;
  inject('auth', new Auth(store));
};
export default authPlugin;